/*
* Carbon Theme
*
* Use this file to add custom Javascript to Carbon.
* In order to use this file you will need to open layout/theme.liquid and add
* <script src="{{ 'custom.js' | asset_url }}" defer="defer"></script>
*/

(function() {
  // Add custom code below this line
  if (document.querySelector(".header__mobile__hamburger")) {
    document.querySelector(".header__mobile__hamburger")?.addEventListener("click", function () {
      document.querySelector("body").classList.add("open-menu");
    });
  }


  if (document.querySelector("mobile-menu .drawer__underlay")) {
    document.querySelector("mobile-menu .drawer__underlay").addEventListener("click", function () {
      document.querySelector("body").classList.remove("open-menu");
    });
  }


  const headerBar = document.querySelector('.page-header');

  if (headerBar) {
    window.addEventListener('scroll', () => {
      const headerBarHeight = headerBar.offsetHeight;
      const scrollTop = window.scrollY;
      if (scrollTop > headerBarHeight) {
        document.querySelector("mobile-menu .drawer__inner").classList.add("sticky-header");
      } else {
        document.querySelector("mobile-menu .drawer__inner").classList.remove("sticky-header");
      }
    });
  }

  const productCardRootsSelector =
    '[data-section-type="product-grid"], [data-section-type="collection"], [data-related-section], collection-component';

  function isProductInfoHidden(productInfo) {
    if (!productInfo) return false;

    const style = window.getComputedStyle(productInfo);

    return style.visibility === 'hidden' || parseFloat(style.opacity) === 0;
  }

  function rebuildTitleFromData(productItem, productInfo) {
    const baseTitle = productItem.dataset.cardTitle?.trim();

    if (!baseTitle) return false;

    const titleText = productInfo.querySelector('.product-item__title-text');
    const titleBlock = productInfo.querySelector('.product-item__title');

    if (titleText) {
      titleText.textContent = baseTitle;

      const shade = productItem.dataset.cardShade?.trim();
      let shadeEl = productInfo.querySelector('.product-item__title-shade');

      if (shade) {
        if (!shadeEl && titleBlock) {
          shadeEl = document.createElement('span');
          shadeEl.className = 'product-item__title-shade';
          titleBlock.appendChild(shadeEl);
        }

        if (shadeEl) {
          shadeEl.textContent = ` - ${shade}`;
        }
      } else if (shadeEl) {
        shadeEl.remove();
      }

      return true;
    }

    if (titleBlock) {
      const shade = productItem.dataset.cardShade?.trim();
      titleBlock.textContent = shade ? `${baseTitle} - ${shade}` : baseTitle;
      return true;
    }

    return false;
  }

  function restoreProductCardFromTemplate(productItem, productInfo) {
    const template = productInfo.querySelector('template[data-product-card-default]');
    const defaultHtml = template?.innerHTML?.trim();

    if (!template || !defaultHtml) return false;

    productInfo.querySelectorAll(':scope > :not(template[data-product-card-default])').forEach((node) => {
      node.remove();
    });

    productInfo.insertBefore(document.createRange().createContextualFragment(defaultHtml), template);
    return true;
  }

  function ensureProductInfoVisible(productInfo) {
    if (!productInfo) return;

    productInfo.removeAttribute('style');
    productInfo.classList.remove('product-item__info--force-visible');
  }

  function fixProductCard(productItem) {
    const variantTitle = productItem.querySelector('.variant__title');
    const currentLink = productItem.querySelector('.sibling__link--current');

    if (!currentLink) return;

    const tooltip = currentLink.closest('tooltip-component');
    const tooltipValue = tooltip?.getAttribute('data-tooltip');
    if (variantTitle && tooltipValue && variantTitle.textContent !== tooltipValue) {
      variantTitle.textContent = tooltipValue;
    }

    if (!productItem?.isConnected) return;
    if (productItem.dataset.swapping === 'true') return;
    if (productItem.matches(':hover')) return;

    const productInfo = productItem.querySelector('.product-item__info');

    if (!productInfo) return;

    const title = productInfo.querySelector('.product-item__title-text, .product-item__title');
    const needsRestore = !title?.textContent?.trim() || isProductInfoHidden(productInfo);

    if (needsRestore) {
      restoreProductCardFromTemplate(productItem, productInfo) || rebuildTitleFromData(productItem, productInfo);
    }

    ensureProductInfoVisible(productInfo);

    productItem.querySelectorAll('[data-quick-add-holder]').forEach((holder) => {
      holder.classList.remove('is-disabled');
    });

    productItem.dispatchEvent(new CustomEvent('theme:product-card:reset', {bubbles: true}));
    document.dispatchEvent(
      new CustomEvent('theme:tooltip:close', {
        bubbles: false,
        detail: {
          hideTransition: false,
        },
      })
    );
  }

  function bindProductCards(root) {
    root.querySelectorAll('product-item:not([data-pgi-reset-bound])').forEach((productItem) => {
      productItem.setAttribute('data-pgi-reset-bound', '');

      productItem.addEventListener('mouseenter', () => {
        const productInfo = productItem.querySelector('.product-item__info');

        if (productInfo) {
          productInfo.classList.remove('product-item__info--force-visible');
          productInfo.removeAttribute('style');
        }
      });

      productItem.addEventListener('mouseleave', () => {
        window.requestAnimationFrame(() => fixProductCard(productItem));
      });
    });
  }

  function handleSwappedProductCard(event) {
    const swapped = event.detail?.element;
    const productItem = swapped?.matches?.('product-item') ? swapped : swapped?.closest?.('product-item');

    if (!productItem) return;

    productItem.removeAttribute('data-pgi-reset-bound');
    productItem.removeAttribute('data-swapping');

    const root = productItem.closest(productCardRootsSelector);
    if (root) bindProductCards(root);

    window.requestAnimationFrame(() => {
      fixProductCard(productItem);
      window.setTimeout(() => fixProductCard(productItem), 50);
    });
  }

  window.repairProductCardInfo = fixProductCard;

  document.addEventListener('DOMContentLoaded', function() {
    const roots = document.querySelectorAll(productCardRootsSelector);

    if (roots.length == 0) return;

    roots.forEach((root) => {
      function updateAllSiblings() {
        root.querySelectorAll('product-item-siblings').forEach((container) => {
          const variantTitle = container.parentElement.querySelector('.variant__title');
          const currentLink = container.querySelector('.sibling__link--current');

          if (!currentLink) return;

          const tooltip = currentLink.closest('tooltip-component');
          const tooltipValue = tooltip?.getAttribute('data-tooltip');

          if (variantTitle && tooltipValue && variantTitle.textContent !== tooltipValue) {
            variantTitle.textContent = tooltipValue;
          }
        });
      }

      bindProductCards(root);
      updateAllSiblings();

      root.querySelectorAll('product-item').forEach((productItem) => {
        productItem.addEventListener('mouseenter', updateAllSiblings);
      });

      document.addEventListener('theme:scroll:unlock', () => {
        root.querySelectorAll('product-item').forEach((productItem) => fixProductCard(productItem));
      });
    });

    document.addEventListener('theme:html:change', handleSwappedProductCard);
  });

  //Remove scrollbar from body when drawer is open
  const body = document.querySelector('body');
  const drawer = document.querySelector('.drawer--cart');

  if (drawer) {
    const observer = new MutationObserver(() => {
      if (drawer.classList.contains('is-open')) {
        body.style.overflow = 'hidden';
      } else {
        body.style.overflow = '';
      }
    });

    observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  function updateShadeProperty(container, variant) {
    const shadeInput = container?.querySelector('[data-shade-property]');

    if (!shadeInput || !variant) return;

    const optionIndex = shadeInput.getAttribute('data-shade-option-index');

    if (optionIndex === null || optionIndex === '') return;

    if (variant.options?.[optionIndex]) {
      shadeInput.value = variant.options[optionIndex];
    }
  }

  document.addEventListener('theme:variant:change', (event) => {
    const container = event.target.closest('[data-quick-add-modal]') || event.target.closest('product-form');

    if (!container || !event.detail?.variant) return;

    updateShadeProperty(container, event.detail.variant);
  });

})();
